import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '..';
import { Button } from 'react-bootstrap';
window.JSZip = jszip;
pdfMake.vfs = pdfFonts.pdfMake?.vfs;
const TrucksPageLayer = ({jobsData}) => {
     const [newTruck,setNewTruck] = useState(false)
     const [showMessage,setShowMessage] = useState({
      show: false,
      message: '',
      type: 'error'
     })
      const history = useNavigate()
  const handleDelete = async(id)=>{
    
    let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
     }
     let response = await fetch(`https://api.towrankers.com/api/user/delete/${id}`, { 
       method: "DELETE",
       headers: headersList
     });
     let data = await response.json();
     if(data.message=="User deleted successfully"){
        window.location.reload();
     }
  
   
  }
    useEffect(() => {
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
        dom: 'Bfrtip',
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
         columns: [
            { data: 'name',
            render: function (data, type, row) {
              return `<button style="cursor: pointer;" class="edit-btn text-primary" data-id="${row.id}">${row.name}</button>`
            }
          },
            { data: 'type' },
            { data: 'duty' },
            { data: 'license_plate',
            render: function (data, type, row) {
              if(data === "" || data === null){
                return 'N/a';
              }else{
                return data

              }
            },
          },
          
            
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          
          const id = $(this).data('id');
         
          history(`/view-truck/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);
    const [truckData,setTruckData] = useState({
      name:'',
      type: 'Unspecified',
      duty:'Unspecified',
    })
    const addTruckIntoDB = async (event)=>{
      const value = JSON.parse(localStorage.getItem('user'))

      event.preventDefault()
      if(truckData.name == ''){
        setShowMessage({
          show: true,
          message: 'Truck name is required',
          type: 'error'
         })
        return false;
      }else{
        let body = JSON.stringify({
          name : truckData.name,
          type: truckData.type,
          duty: truckData.duty,
          affiliate_id : value.id
        })
        const apiCall = await fetch(
          `${API_URL}/api/truck/create`, {
            body :body,
            method :'POST',
            headers:{
              'Content-Type' : 'application/json',
            }
          }
         )
         const response = await apiCall.json();
         
         if(apiCall.status === 200){
          setShowMessage({
            show: true,
            message: 'You successfully added the truck',
            type: 'success'
           })
         }else{
          setShowMessage({
            show: true,
            message: 'Error while adding the truck. Please try again',
            type: 'error'
           })
         }

      }

    }
    return (
        <div className="card basic-data-table">
       
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
               
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">Duty</th>
                <th scope="col">Plate No</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default TrucksPageLayer